var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    transform: "translate(-819 -354.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 24,
    height: 24,
    transform: "translate(819 354.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sms",
    d: "M7,3.5c-3,0-5,1.5-5,5v7c0,3.5,2,5,5,5H17c3,0,5-1.5,5-5v-7c0-3.5-2-5-5-5Zm7.34,8.59a3.861,3.861,0,0,1-4.68,0L6.53,9.59a.769.769,0,0,1-.12-1.06.748.748,0,0,1,1.05-.12l3.13,2.5a2.386,2.386,0,0,0,2.81,0l3.13-2.5a.738.738,0,0,1,1.05.12.759.759,0,0,1-.11,1.06Z",
    transform: "translate(819 354.5)",
    fill: "#56b3e5",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ed23adac5ffe1dd43edf615242e093ea.svg";
export { ForwardRef as ReactComponent };